module.exports = __webpack_public_path__ + "img/surgical-consent-form.c36c81e9.svg";